var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3635(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0.3)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635",
    transform: "translate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50518",
    "data-name": "Path 50518",
    d: "M11.492,17.183c1.327.273,4.609,1.307,5.1,2.97h.867c-.427-2.314-4.273-3.431-5.459-3.721V14.653a.423.423,0,0,0-.846,0v2.115a.423.423,0,0,0,.338.415",
    transform: "translate(1.115 1.423)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50519",
    "data-name": "Path 50519",
    d: "M3.981,20.153c.492-1.664,3.773-2.7,5.1-2.97a.424.424,0,0,0,.338-.415V14.653a.423.423,0,1,0-.846,0v1.779c-1.186.29-5.034,1.407-5.46,3.721Z",
    transform: "translate(0.311 1.423)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50520",
    "data-name": "Path 50520",
    d: "M4.943,11.807a1.481,1.481,0,1,1,0-2.961C6,8.846,6,9.883,6,10.327s0,1.481-1.058,1.481m0-2.115a.635.635,0,1,0,0,1.269c.136,0,.211,0,.211-.635s-.075-.635-.211-.635",
    transform: "translate(0.346 0.885)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50521",
    "data-name": "Path 50521",
    d: "M15.288,11.807c-1.058,0-1.058-1.037-1.058-1.481s0-1.481,1.058-1.481a1.481,1.481,0,1,1,0,2.961m0-2.115c-.136,0-.211,0-.211.635s.075.635.211.635a.635.635,0,0,0,0-1.269",
    transform: "translate(1.423 0.885)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50522",
    "data-name": "Path 50522",
    d: "M10.5,16A5.506,5.506,0,0,1,5,10.5V9.655A5.45,5.45,0,0,1,6.718,5.662,2.576,2.576,0,0,1,9.56,5.225a2.321,2.321,0,0,0,1.881,0,2.574,2.574,0,0,1,2.84.437A5.447,5.447,0,0,1,16,9.655V10.5A5.506,5.506,0,0,1,10.5,16M8.445,5.83A1.659,1.659,0,0,0,7.3,6.275,4.614,4.614,0,0,0,5.846,9.655V10.5a4.654,4.654,0,0,0,9.308,0V9.655A4.614,4.614,0,0,0,13.7,6.275,1.734,1.734,0,0,0,11.787,6,3.163,3.163,0,0,1,9.212,6a1.873,1.873,0,0,0-.767-.167",
    transform: "translate(0.5 0.498)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50523",
    "data-name": "Path 50523",
    d: "M4.654,10.384a.424.424,0,0,1-.423-.424V8.269a6.346,6.346,0,0,1,12.693,0V9.961a.423.423,0,1,1-.846,0V8.269a5.5,5.5,0,0,0-11,0V9.961a.424.424,0,0,1-.424.424",
    transform: "translate(0.423 0.192)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3635);
export default __webpack_public_path__ + "static/media/Group3635.f6d29c31ac73539082d2bd34016beddf.svg";
export { ForwardRef as ReactComponent };